
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { Box, Paper } from '@mui/material';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FeaturedEventProps } from '../../interfaces';

interface HeroSliderProps {
    featuredEvents: FeaturedEventProps[];
}
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

import 'swiper/css/effect-fade';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';



export const HeroSlider = ({ featuredEvents }: HeroSliderProps) => {

    const swiperSettings = {
        modules: [Navigation, Pagination, EffectFade],
        effect: 'fade', // Establece el efecto a 'fade'
        fadeEffect: {
            crossFade: true
        },
        speed: 1000,
        spaceBetween: 0,
        centeredSlides: true,
        pagination: {
            clickable: true,
        },
        navigation: true,
        loop: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
    };

    const navigate = useNavigate();



    const handleNavigate = (eventId: number) => {
        navigate(`/event/${eventId}`);
    };

    return (

        <Box component={Paper} elevation={15}
            sx={{ height: { xs: '65vh', md: '90vh' }, backgroundColor: 'black' }}>

            <Swiper {...swiperSettings}>
                {featuredEvents.map((event: FeaturedEventProps) => (
                    <SwiperSlide key={event.id} onClick={() => handleNavigate(+event.id)}>
                        <Box
                            sx={{
                                borderRadius: 1,
                                height: { xs: '65vh', md: '90vh' },
                                backgroundImage: `url(${event.bannerAlt})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '&:before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                    zIndex: 1,

                                },
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    )
}
